export default [['Hunting calls', '#bebada'],
  ['Disaster ballads', '#ffcc00'],
  ['Bawdy songs', '#ff7f00'],
  ['War songs', '#fdbf6f'],
  ['Schottisches', '#ff7f00'],
  ['Drinking songs', '#ff7f00'],
  ['Marches', '#fdbf6f'],
  ['Animal calls', '#bebada'],
  ['Humorous recitations', '#ff7f00'],
  ['Courting songs', '#f768a1'],
  ['Tall tales', '#ffffbf'],
  ['Waltzes', '#ff7f00'],
  ['Counting songs', '#a6d854'],
  ['Love songs', '#f768a1'],
  ['Hunting songs', '#bebada'],
  ['Prayers', '#cb181d'],
  ['Narratives', '#ffcc00'],
  ['Folk drama', '#ffcc00'],
  ['Religious drama', '#cb181d'],
  ['Hymns', '#cb181d'],
  ['Humorous songs', '#ff7f00'],
  ['Announcements', '#ffffbf'],
  ['Field hollers', '#44CFCB'],
  ['Nursery rhymes', '#a6d854'],
  ['Cowboy songs', '#bebada'],
  ['Corridos', '#ffcc00'],
  ['Fiddle tunes', '#b15928'],
  ['Lullabies', '#a6d854'],
  ['Spoken word', '#ffffbf'],
  ['Dance music', '#ff7f00'],
  ['Ballads', '#ffcc00'],
  ['Work songs', '#44CFCB'],
  ['Children\'s songs', '#a6d854'],
  ['Religious songs', '#cb181d']]


// WEBPACK FOOTER //
// ./src/colorMap.js